import { Div, Flex, IPackageJson, LogoRegistro, Version } from '@nic/ui-comps'
import React from 'react'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import packageJson from '../package.json'
import { faCopyright } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider } from 'antd'

export function Footer() {
  return (
    <Flex direction={'column'} justify={'center'} style={{ width: '100%' }}>
      <Flex
        direction={'row'}
        style={{
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'nowrap',
        }}
      >
        <Version packageJson={packageJson as IPackageJson} style={{ color: '' }} />
        <Divider type={'vertical'} />
        <Div marginRight={'10px'}>darwin</Div>
        <Div marginRight={'10px'}>{new Date().getFullYear()}</Div>
        <FontAwesomeIcon color='gray' icon={faCopyright as IconProp} />
        <Div marginLeft={'10px'}>Registro</Div>

        <LogoRegistro style={{ width: 25, height: 25, margin: '0px 2px' }} />
      </Flex>
    </Flex>
  )
}
